export function tabs() {
	const buttons = document.querySelectorAll('.tab-button');

	if (!buttons) return;

	const removeActiveState = (button) => {
		// Toggle aria-expanded and aria-selected attributes
		button.setAttribute('aria-expanded', false);
		// button.setAttribute('aria-selected', false);

		// get associated content div
		const content = document.getElementById(button.getAttribute('aria-controls'));

		// Remove active class from associated content div
		content?.classList.remove('active');
	};

	const handleButtonClick = (button) => (event) => {
		event.preventDefault();

		// remove active state from all buttons
		buttons.forEach(removeActiveState);

		// Toggle aria-expanded and aria-selected attributes
		button.setAttribute('aria-expanded', true);
		// button.setAttribute('aria-selected', true);

		// Add active class to associated content div
		const content = document.getElementById(button.getAttribute('aria-controls'));

		content?.classList.add('active');
	};

	buttons.forEach((button) => {
		button.addEventListener('click', handleButtonClick(button));
	});
}
